export const hasBannerSectionData = (bannerSection) => {
  if (!bannerSection) return false;

  if (typeof bannerSection === "string") {
    return bannerSection.trim().length > 0;
  }

  if (Array.isArray(bannerSection)) {
    return bannerSection.some(hasBannerSectionData);
  }

  if (typeof bannerSection === "object") {
    return Object.values(bannerSection).some(hasBannerSectionData);
  }

  return Boolean(bannerSection);
};
